import { Controller } from "@hotwired/stimulus"

// Replaces a loaded turbo-frame with its contents, so lazily loaded pages land
// as direct children of the list. Live updates prepend to the list and rely on
// Turbo removing a same-id direct child; a row nested in a page frame would be
// duplicated instead.
export default class extends Controller {
  // Turbo starts before Stimulus, so a page can finish loading before this
  // controller is there to see its frame-load.
  connect() {
    if (this.element.hasAttribute("complete")) this.unwrap()
  }

  // A row that moved after its page rendered (a backdated note, a draft
  // published at the top) comes back on a later page. The copy already in the
  // list stays.
  unwrap() {
    const fresh = Array.from(this.element.childNodes).filter((node) => !this.listedElsewhere(node))
    this.element.replaceWith(...fresh)
  }

  private listedElsewhere(node: ChildNode): boolean {
    if (!(node instanceof Element) || !node.id) return false

    const listed = document.getElementById(node.id)
    return listed !== null && !this.element.contains(listed)
  }
}
